export default {"src":"/_next/static/media/logo.753928eb.svg","height":142,"width":425};